export default __webpack_public_path__ + "static/media/pixellab--graphic-design--02--1200x900.be000c72.jpg";